// Formatage FR. Montants ronds sans décimales (« 14 € »), sinon au centime
// (« 2,10 € ») : les crédits ne sont plus arrondis à l'euro (2026-10-12).
export function fmtEuro(n) {
  const c = Math.round((Number(n) || 0) * 100) / 100;
  return Number.isInteger(c)
    ? c.toLocaleString('fr-FR') + ' €'
    : c.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
}
